import useUserStore from '@/stores/useUserStore';
import { getProfile } from '@/requests/useProfile';
import { syncSubjectToCookie } from '@/utils/subject';
import anewSignIn from '@/utils/anewSignIn';
import Axios from '@/utils/Axios';
import Logger from '@/utils/Logger';

async function loadSchool() {
  const { data } = await Axios.get<
    {
      current: boolean;
      id: number;
      name: string;
      role: string;
    }[]
  >('/teachers/schools');

  useUserStore.setState({
    schools: data.map((v) => ({
      id: String(v.id),
      name: v.name,
    })),
    currentSchoolId: String(data.find((v) => v.current)?.id || ''),
  });
}

let alreadyLoadedUserProfile = false;

/**
 * 加载教师 profile 与学校列表，写入 useUserStore（订阅负责同步 user_store cookie）。
 *
 * 失败语义：getProfile 返回 401/403 视为会话失效跳登录；其余失败（网络错误/5xx）
 * 与 loadSchool 失败仅记录日志、保留会话，避免偶发接口失败把用户踢出登录。
 */
export default async function loadUserProfile() {
  if (alreadyLoadedUserProfile && useUserStore.getState().isFilled()) return;

  try {
    const profile = await getProfile();
    useUserStore.setState({
      id: String(profile.id),
      name: profile.name,
      prefer: profile.prefer || false,
      unit: profile.unit,
      section: profile.section,
    });

    syncSubjectToCookie();

    try {
      await loadSchool();
    } catch (schoolError) {
      Logger.debug(schoolError, '加载学校列表失败');
    }

    alreadyLoadedUserProfile = true;
  } catch (e) {
    const status = (e as { response?: { status?: number } })?.response?.status;
    if (status === 401 || status === 403) {
      anewSignIn('身份验证失败，请重新登录');
      return;
    }

    Logger.debug(e, '加载用户信息失败');
  }
}
